<template>
  <div class="card">
    <div class="background">
      <div class="layout-tile">
        <p class="layout-title">核心功能:快速切换功能</p>
      </div>
      <div class="layout-tile">
        <img
          class="layout-img"
          src="@/assets/1_1.png"
          alt="进入快速切换配置界面的示意图"
        />
        <div class="layout-contents">
          <p class="layout-desc">进入你的快速切换配置</p>
        </div>
      </div>
      <div class="layout-tile">
        <div class="layout-contents">
          <p class="layout-desc">支持配置六大类型:</p>
          <p class="layout-desc">1.Host</p>
          <p class="layout-desc">2.注册表</p>
          <p class="layout-desc">3.文本</p>
          <p class="layout-desc">4.文件</p>
          <p class="layout-desc">5.批处理</p>
          <p class="layout-desc">6.Powershell</p>
        </div>
        <img
          class="layout-img"
          src="@/assets/1_2.png"
          alt="可配置的六大类型列表:Host、注册表、文本、文件、批处理、Powershell"
        />
      </div>
      <div class="layout-tile">
        <img
          class="layout-img"
          src="@/assets/1_3.png"
          alt="对各类型进行定制化设置以及导入导出分享的界面"
        />
        <div class="layout-contents">
          <p class="layout-desc">对各类型进行定制化设置</p>
          <p class="layout-desc">可绑定快捷键快捷食用</p>
          <p class="layout-desc">支持导入及导出进行分享</p>
        </div>
      </div>
      <div class="layout-tile">
        <div class="layout-contents">
          <p class="layout-desc">右键入口或拖盘可快速在菜单中使用</p>
        </div>
        <img
          class="layout-img"
          src="@/assets/1_4.png"
          alt="右键入口或托盘菜单中快速使用快速切换功能的示意图"
        />
      </div>
    </div>
  </div>
</template>

<style scoped>
.layout-tile {
  background: #ffd2b2;
}
.layout-title {
  color: #000;
}
.layout-desc {
  color: #333;
}
</style>
